import { ZoomImageTile } from "./zoom-image-tile";
import { Deserializable, Deserialize } from "../helpers/serialization";

export class MosaicDefinition extends Deserializable
{
    @Deserialize()
    public file: string;

    @Deserialize()
    public tiles_x: number;

    @Deserialize()
    public tiles_y: number;

    // @Deserialize({isArray:true})
    // public tiles: ZoomImageTile[] = [];
}